/**
 * Apple ToP 3.8.1 — staff without setup permission cannot accept terms or open the wizard.
 * @param {import('quasar').QVueGlobals} $q
 * @param {(key: string) => string} t
 */
export function showIphoneTopAdminRequiredDialog ($q, t) {
  return $q.dialog({
    title: t('iphoneTopSetup.adminRequiredTitle'),
    message: t('iphoneTopSetup.adminRequiredBody'),
    ok: { label: t('common.ok'), color: 'primary' }
  })
}
